import React from "react";
import { Box, Typography } from "@mui/material";
import { deepPurple } from "@mui/material/colors";

import { Currency } from "fond/types";
import { Scale } from "fond/utils/bucket";
import { formatCurrency } from "fond/utils/currency";

import RadialGauge from "./RadialGauge";

import { AverageHighlightBox } from "./BomCostPerServiceLocationChart.styles";

const GAUGE_WIDTH = 220;

interface CostGaugeSummaryProps {
  min: number;
  max: number;
  average: number;
  scale?: Scale;
  currency?: Currency;
}

const CostGaugeSummary: React.FC<CostGaugeSummaryProps> = ({ min, max, average, scale = "linear", currency }) => (
  <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" flex={4} minHeight={0} gap={2} p={2} overflow="hidden">
    <Box display="flex" alignItems="center" justifyContent="center" flex={1} minHeight={0} minWidth={0} width="100%">
      <RadialGauge min={min} max={max} value={average} width={GAUGE_WIDTH} scale={scale} />
    </Box>
    <Box display="flex" alignItems="center" justifyContent="space-evenly" width="100%">
      <Box textAlign="center">
        <Typography variant="h6" fontWeight={700}>
          {formatCurrency(min, { notation: "compact", currency })}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Min
        </Typography>
      </Box>
      <AverageHighlightBox>
        <Typography variant="h6" fontWeight={700} sx={{ color: deepPurple[700] }}>
          {formatCurrency(average, { notation: "compact", currency })}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Average
        </Typography>
      </AverageHighlightBox>
      <Box textAlign="center">
        <Typography variant="h6" fontWeight={700}>
          {formatCurrency(max, { notation: "compact", currency })}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Max
        </Typography>
      </Box>
    </Box>
  </Box>
);

export default CostGaugeSummary;
